var parent = require('../../stable/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/assign.js
// module id = 3488
// module chunks = 25